<template>
	<div class="form-page">

		<div class="pad-20">
			<el-tabs v-model="type" @tab-click="handleClick">
				<el-tab-pane :label="$t('立即交易')" name="0"></el-tab-pane>
				<el-tab-pane :label="$t('定时交易')" name="1"></el-tab-pane>
			</el-tabs>

			<div class="form-div dis-fle ali-cen">
				<div class="flex-1">
					<div class="form-item">
						<el-select v-model="zForm.seconds" :placeholder="$t('请选择')" style="width: 100%;">
							<el-option v-for="item in timeList" :key="`${item.seconds}1`"
								:label="`${item.seconds_desc} - ${item.profit_ratio}%`"
								:value="item.seconds"></el-option>
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('交易区间') }}</span>
						</el-select>
					</div>
					<div class="form-item" v-if="type == 1">
						<el-date-picker v-model="zForm.time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
							:placeholder="$t('选择时间')" style="width: 100%;">
						</el-date-picker>
					</div>
					<div class="form-item">
						<el-input v-model="zForm.amount" :placeholder="$t('请输入')" size="medium">
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('投入金额(USDT)') }}</span>
						</el-input>
					</div>
					<!-- <div class="form-item">
						<el-input v-model="zForm.pay_password" :placeholder="$t('请输入')" size="medium">
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('资金密码') }}</span>
						</el-input>
					</div> -->
					<div class="form-item slider-div">
						<el-slider v-model="zForm.slider" :marks="marks"></el-slider>
					</div>
					<div class="form-item dis-fle ali-cen jus-bet txt-14">
						<div class="left">
							<span class="label">{{ $t('余额') }}</span>
							<span class="value">{{ money }} USDT</span>
						</div>
					</div>
					<div class="form-item dis-fle ali-cen jus-bet txt-14">
						<div class="left">
							<span class="value">{{ $t('当前投资') }}</span>
						</div>
					</div>
					<div class="form-item dis-fle ali-cen jus-bet txt-14">
						<div class="left">
							<span class="label">{{ $t('投资方向') }}</span>
							<span class="value">{{ $t('买多') }}</span>
						</div>
						<div class="right">
							<span class="label">{{ $t('投资收益率') }}</span>
							<span class="value">{{ zTime.profit_ratio || 0 }}%</span>
						</div>
					</div>
					<div class="form-item dis-fle ali-cen jus-bet txt-14">
						<div class="left">
							<span class="label">{{ $t('投资金额') }}</span>
							<span class="value">${{ zForm.amount || '0.00' }}</span>
						</div>
						<div class="right">
							<span class="label">{{ $t('投资状态') }}</span>
							<span class="value">{{ $t('暂无数据') }}</span>
						</div>
					</div>
					<div class="form-item">
						<div class="but" @click="submit(1)">{{ $t('买涨') }}</div>
					</div>
					<div class="form-item dis-fle ali-cen jus-bet txt-14">
						<div class="left">
							<span class="label">{{ $t('最低') }}</span>
							<span class="value">${{ zTime.min || '0.00' }} USDT</span>
						</div>
						<div class="right">
							<span class="label">{{ $t('最高') }}</span>
							<span class="value">${{ zTime.max || '0.00' }} USDT</span>
						</div>
					</div>
				</div>

				<!-- 右侧 -->
				<div class="flex-1" style="margin-left: 20px;">
					<div class="form-item">
						<el-select v-model="dForm.seconds" :placeholder="$t('请选择')" style="width: 100%;">
							<el-option v-for="item in timeList" :key="`${item.seconds}2`"
								:label="`${item.seconds_desc} - ${item.profit_ratio}%`"
								:value="item.seconds"></el-option>
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('交易区间') }}</span>
						</el-select>
					</div>
					<div class="form-item" v-if="type == 1">
						<el-date-picker v-model="dForm.time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
							:placeholder="$t('选择时间')" style="width: 100%;">
						</el-date-picker>
					</div>
					<div class="form-item">
						<el-input v-model="dForm.amount" :placeholder="$t('请输入')" size="medium">
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('投入金额(USDT)') }}</span>
						</el-input>
					</div>
					<!-- <div class="form-item">
						<el-input v-model="dForm.pay_password" :placeholder="$t('请输入')" size="medium">
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('资金密码') }}</span>
						</el-input>
					</div> -->
					<div class="form-item slider-div">
						<el-slider v-model="dForm.slider" :marks="marks"></el-slider>
					</div>
					<div class="form-item dis-fle ali-cen jus-bet txt-14">
						<div class="left">
							<span class="label">{{ $t('余额') }}</span>
							<span class="value">{{ money }} USDT</span>
						</div>
					</div>
					<div class="form-item dis-fle ali-cen jus-bet txt-14">
						<div class="left">
							<span class="value">{{ $t('当前投资') }}</span>
						</div>
					</div>
					<div class="form-item dis-fle ali-cen jus-bet txt-14">
						<div class="left">
							<span class="label">{{ $t('投资方向') }}</span>
							<span class="value">{{ $t('买空') }}</span>
						</div>
						<div class="right">
							<span class="label">{{ $t('投资收益率') }}</span>
							<span class="value">{{ dTime.profit_ratio || 0 }}%</span>
						</div>
					</div>
					<div class="form-item dis-fle ali-cen jus-bet txt-14">
						<div class="left">
							<span class="label">{{ $t('投资金额') }}</span>
							<span class="value">${{ dForm.amount || '0.00' }}</span>
						</div>
						<div class="right">
							<span class="label">{{ $t('投资状态') }}</span>
							<span class="value">{{ $t('暂无数据') }}</span>
						</div>
					</div>
					<div class="form-item">
						<div class="but but1" @click="submit(2)">{{ $t('买跌') }}</div>
					</div>
					<div class="form-item dis-fle ali-cen jus-bet txt-14">
						<div class="left">
							<span class="label">{{ $t('最低') }}</span>
							<span class="value">${{ dTime.min || '0.00' }} USDT</span>
						</div>
						<div class="right">
							<span class="label">{{ $t('最高') }}</span>
							<span class="value">${{ dTime.max || '0.00' }} USDT</span>
						</div>
					</div>
				</div>
			</div>

			<div class="tip-div">
				<div class="title txt-16">{{ intro.title }}</div>
				<p v-html="intro.content"></p>
			</div>
		</div>
	</div>
</template>

<script>

import { post } from '@/http/request'
import apis from '@/http/api'

class FormData {
	constructor() {
		// product_id 产品id
		// direction 1 = 买涨, 2 = 买跌
		// seconds 秒
		// amount 金额
		// type 0 = 立即交易, 1 = 定時交易
		// time 2025 -09 - 19 00:00:00 时间
		this.slider = 0;
		this.product_id = "";
		this.direction = "";
		this.seconds = "";
		this.amount = "";
		this.type = "";
		this.time = "";
		this.pay_password = "";
	}
}
export default {
	props: {
		productInfo: {
			type: Object,
			default: () => {
				return {}
			}
		},
		money: {
			type: Number,
			default: 0
		},
	},
	computed: {
		intro() {
			return this.productInfo.intro_delivery || {}
		},
		timeList() {
			return this.productInfo.timeList || []
		},
		zTime() {
			let seconds = this.zForm.seconds || ''
			return this.timeList.find(item => item.seconds == seconds) || {}
		},
		dTime() {
			let seconds = this.dForm.seconds || ''
			return this.timeList.find(item => item.seconds == seconds) || {}
		},
	},
	watch: {
		'productInfo.id'() {
			this.zForm = new FormData()
			this.dForm = new FormData()
		}
	},
	data() {
		return {
			type: '0',

			zForm: new FormData(),
			dForm: new FormData(),

			marks: {
				0: '0%',
				25: '25%',
				50: '50%',
				75: '75%',
				100: '100%',
				// 75: {
				//   style: {
				//     color: '#1989FA'
				//   },
				//   label: this.$createElement('strong', '50%')
				// }
			}
		};
	},
	methods: {
		handleClick() {
			this.zForm.time = ''
			this.dForm.time = ''
		},

		/**
		 * direction 1涨 2跌
		 */
		submit(direction) {
			let formData = this.zForm
			if (direction == 2) {
				formData = this.dForm
			}
			post(apis.orderSubmit, {
				...formData,
				direction,
				type: this.type,
				product_id: this.productInfo.id,
			}).then(res => {
				if (res.code != 1) return
				this.$notify.success(res.msg)
				this.$emit('modify')
				this.$emit('initList')

				if (direction == 1) {
					this.zForm = new FormData()
				} else if (direction == 2) {
					this.dForm = new FormData()
				}
			})
		},
	},
};
</script>
<style lang="scss" scoped>
.form-page {

	.tip-div {
		margin-top: 16px;
		border-top: 1px solid #31323f;

		.title {
			padding: 16px 0px;
		}

		p {
			font-size: 14px;
			color: #888;
			margin: 0px;
		}
	}

	.form-div {
		.form-item {
			margin-bottom: 10px;

			&.slider-div {
				margin-bottom: 32px;
			}

			.but {
				margin: 22px 0;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;
				background-color: #00f0ff;
				color: #000;
				line-height: 46px;
				font-size: 16px;
				border-radius: 30px;

				&.but1 {
					background: #ff4834;
				}
			}

			.label {
				color: #888;
				margin-right: 10px;
			}

			::v-deep .el-input-group__prepend {
				background-color: #ffffff00;
			}

			::v-deep .el-input__inner {
				text-align: right;
				height: 44px;
				line-height: 44px;
				padding-left: 130px;
			}

			.slot-prepend {
				color: #888;
				display: inline-block;
				width: 130px;
				// padding-left: 10px;
				height: 44px;
				line-height: 44px;
			}

			::v-deep .el-slider {
				.el-slider__bar {
					background-color: #409eff;
				}

				.el-slider__button {
					border: 2px solid #409eff;
					background-color: #fff;
				}

				.el-slider__stop {
					background-color: #fff;
				}

				.el-slider__runway {
					background-color: #2e3244;
				}
			}
		}
	}
}
</style>